module.exports = __webpack_public_path__ + "img/gy.cd700153.svg";